import Navigation from "./navigation";
import SiteFavicon from "./components/SiteFavicon";

function App() {
  return (
    <>
      <SiteFavicon />
      <Navigation />
    </>
  );
}

export default App;
